import Str from 'base/string';
import Report11332 from 'report/11332';

let currentDialog = null;

let info = {
  receiveCallback: null,
  appRoleListMap: null,
  currentRoleList: [],
  currentRegionList: [],
  currentRole: null,
  currentRegion: null,
  currentAppId: '',
  isSameGame: true,
  hasBindRole: false, // 是否有缓存角色信息
  isCurrentRoleSaved: false, // 当前选择角色是否为缓存角色
  hasSelectRegion: false,
  currentTargetPageName: 'region',
  currentFromPageName: 'saved',
  ssid: 0,
  selectOtherRole: false,
  titleText: '选择领取的角色',
  confirmText: '确认领取',
  cancelText: '取消',
  currentSelectCacheRoleIndex: 0,
  currentSelectRegionIndex: -1,
  currentSelectRegionRoleIndex: 0,
  clickLocked: false,
  cancelCallback: null,
  failCallback: null
};

// 封装区服角色选择组件操作逻辑
let options = {
  insertStyle: function() {
    var dialogDom = document.getElementById('welfare-center-half_screen_region');
    if (!dialogDom) {
      var dom = document.createElement('style');
      dom.setAttribute('type', 'text/css');
      dom.setAttribute('id', 'welfare-center-half_screen_region');

      const style = `
        .region-dialog-wraper_cache-role-list {
            max-height: 50vh;
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
        }

        .region-dialog-wraper_region-list {
            overflow-y: scroll;
            max-height: 68vh;
            -webkit-overflow-scrolling: touch;
        }

        .role-dialog-title {
            margin-left: 24px;
            margin-right: 24px;
            font-size: 15px;
            font-family: PingFangSC-Medium, sans-serif;
            color: rgba(0, 0, 0);
            padding-top: 10px;
            padding-bottom: 21px;
            border-bottom: 0.5px solid rgba(0, 0, 0, 0.05);
        }

        .wg_dark_mode .role-dialog-title {
            color: rgba(255, 255, 255, 0.8);
            border-bottom: 0.5px solid rgba(255, 255, 255, 0.05);
        }

        .role-dialog-gift {
            padding: 16px 8px 16px 0;
            margin-left: 24px;
            margin-right: 24px;
            border-bottom: 0.5px solid rgba(0, 0, 0, 0.05);
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-family: PingFangSC-Regular, sans-serif;
        }
        .role-dialog-gift:last-child{
            margin-bottom: 40px;
        }
        .wg-half-screen-dialog__content-has-bottom .role-dialog-gift:last-child{
            margin-bottom: auto;
        }

        .wg_dark_mode .role-dialog-gift {
            border-bottom: 0.5px solid rgba(255, 255, 255, 0.05);
        }

        .role-dialog-gift .role-dialog-gift_title {
            font-size: 17px;
            color: rgba(0, 0, 0, 0.9);
        }

        .wg_dark_mode .role-dialog-gift_title {
            color: rgba(255, 255, 255, 0.8);
        }

        .role-dialog-gift .role-dialog-gift_content {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.3);
        }

        .wg_dark_mode .role-dialog-gift_content {
            color: rgba(255, 255, 255, 0.3);
        }

        .role-dialog-gift .role-dialog-gift_content-norole {
            color: #ffc000;
        }

        .role-dialog-other {
            margin-left: 24px;
            padding-top: 16px;
            padding-bottom: 8px;
            font-size: 14px;
            color: #576b95;
        }

        .role-dialog-gift_right-selected {
            height: 14px;
            display: none;
        }

        .role-dialog-gift_selected .role-dialog-gift_right-selected {
            display: block;
        }

        .role-dialog-gift_right-arrow {
            height: 14px;
        }

        .region-dialog-gift_content {
            font-size: 17px;
        }

        .region-dialog-title {
            text-align: center;
            position: relative;
        }

        .region-dialog-title .region-dialog-title_arrow {
            position: absolute;
            display: flex;
            align-items: center;
            width: 35px;
        }

        .region-dialog-title .region-dialog-title_arrow .region-dialog-title_arrow-img {
            height: 15px;
        }

        .wg_dark_mode .region-dialog-title .region-dialog-title_arrow .region-dialog-title_arrow-img {
            background-image: url(//mmgame.qpic.cn/image/ad47bf17265f1acb58d82f2116dea434d7fedf1d0424e636bcb4e80afbf96301);
        }
`;

      dom.innerHTML = style;
      var head = document.getElementsByTagName('head')[0];
      head.appendChild(dom);
    }
  },

  getAnimationType: function() {
    let from = info.currentFromPageName,
      to = info.currentTargetPageName,
      type = 'rise';

    if (from === 'saved') {
      type = 'rise';
    }

    if (from === 'region') {
      type = 'slideLeft';
    }

    if (to === 'region' && from !== 'saved') {
      type = 'slideRight';
    }

    if (from === 'role' && to === 'regionRole') {
      type = 'slideRight';
    }

    return type;
  },

  resetInfo: function() {
    info.receiveCallback = null;
    info.appRoleListMap = null;
    info.currentRoleList = [];
    info.currentRegionList = [];
    info.currentRole = null;
    info.currentRegion = null;
    info.currentAppId = '';
    info.hasBindRole = false;
    info.isCurrentRoleSaved = false;
    info.hasSelectRegion = false;
    info.currentSelectCacheRoleIndex = 0;
    info.currentSelectRegionIndex = -1;
    info.currentSelectRegionRoleIndex = 0;
  },

  cgiTool: function(cgi, param) {
    if (cgi.indexOf('?') < 0) {
      cgi += '?';
    }
    let req = {
      data: encodeURIComponent(JSON.stringify(param))
    };
    return cgi + Str.mapToStr(req);
  },

  // 获取用户游戏分区及角色信息
  getUserAppRoleList: function(cbk) {
    let cgi = '/cgi-bin/gamegiftwap/getuserapprolelist';
    let param = {
      req: {
        plattype: WXGAME.Env.isiOS ? 0 : 1
      }
    };
    cgi = options.cgiTool(cgi, param);
    WXGAME.xhrCallCgi(
      cgi,
      {
        method: 'GET'
      },
      function(res) {
        if (res.errcode === 0) {
          info.appRoleListMap = ((res.data || {}).user_app_role_list || {}).app_role_list_map;
        }
        cbk && cbk();
      },
      function(status_err_code) {
        if (info.failCallback && typeof info.failCallback == 'function') {
          info.failCallback(status_err_code);
        }
      }
    );
  },

  // 获取当前游戏区服信息
  getAppPartitionInfo: function(appid, cbk) {
    if (
      info.isSameGame &&
      Array.isArray(info.currentRegionList) &&
      info.currentRegionList.length > 0
    ) {
      // 游戏相同且已有区服列表，不重复请求
      info.currentRegion = info.currentRegionList[info.currentSelectRegionIndex];
      cbk && cbk();
    } else {
      let cgi = '/cgi-bin/gamegiftwap/getapppartitionlist';
      let param = {
        appid: appid,
        plattype: WXGAME.Env.isiOS ? 0 : 1
      };
      cgi = options.cgiTool(cgi, param);
      WXGAME.xhrCallCgi(
        cgi,
        {
          method: 'GET'
        },
        function(res) {
          if (res.errcode === 0) {
            info.currentRegionList = (res.data || {}).item;
            info.currentRegion = info.currentRegionList[info.currentSelectRegionIndex];
          }
          cbk && cbk();
        }
      );
    }
  },

  // 获取当前游戏区服的角色列表
  getPartitionUserList: function(appid, cbk) {
    let cgi = '/cgi-bin/gamegiftwap/getuserpartitionrolelist';
    let _param = {
      appid: appid,
      plattype: WXGAME.Env.isiOS ? 0 : 1,
      partition: Number(info.currentRegion.v)
    };

    cgi = options.cgiTool(cgi, _param);

    WXGAME.xhrCallCgi(
      cgi,
      {
        method: 'GET'
      },
      function(res) {
        if (res.errcode === 0) {
          let data = res.data || {};
          let roleList = data.role || {};
          if (Array.isArray(roleList) && roleList.length > 0) {
            if (roleList[0].rolename === '') {
              // 当前区服无角色时，接口也会返回含有一项rolename为空字符串的数组，要做兼容
              roleList = [];
            }
            let currentRoleList = [];
            roleList.forEach((role) => {
              currentRoleList.push({
                character_name: role.rolename,
                character_no: role.roleid
              });
            });
            info.currentRoleList = currentRoleList;
            if (currentRoleList.length > 0) {
              info.currentRole = currentRoleList[info.currentSelectRegionRoleIndex];
            }
          } else {
            info.currentRoleList = [];
            info.currentRole = null;
          }
        } else {
          info.currentRoleList = [];
          info.currentRole = null;
        }

        cbk && cbk(res);
      }
    );
  },

  // getPartitionUserList: function (appid, cbk) {
  //     let cgi = "/cgi-bin/rolelist?j=" + encodeURIComponent(JSON.stringify({
  //         appid: appid,
  //         partition: info.currentRegion.v,
  //         platid: WXGAME.Env.isiOS ? 0 : 1
  //     }));

  //     info.clickLocked = true;

  //     WXGAME.xhrCallCgi(cgi, {
  //         method: 'GET'
  //     }, function (res) {
  //         if (res.base && res.base.ret === 0) {
  //             let roleList = res.body;
  //             if (roleList.length > 0 && roleList[0].rolename === "") {
  //                 // 当前区服无角色时，接口也会返回含有一项rolename为空字符串的数组，要做兼容
  //                 roleList = [];
  //             }
  //             let currentRoleList = [];
  //             roleList.forEach(role => {
  //                 currentRoleList.push({
  //                     character_name: role.rolename,
  //                     character_no: role.roleid
  //                 })
  //             });
  //             info.currentRoleList = currentRoleList;
  //             if (currentRoleList.length > 0) {
  //                 info.currentRole = currentRoleList[info.currentSelectRegionRoleIndex];
  //             }

  //             info.clickLocked = false;
  //             cbk && cbk();
  //         }
  //     });
  // },

  // 获取用户列表配置
  getRoleListConfig: function() {
    let roleDialogTitle = `<div class="role-dialog-title">${info.titleText}</div>`;
    let dialogHtmlArray = [
      {
        html: roleDialogTitle
      }
    ];

    let roleList = info.currentRoleList;
    // 判断是否有缓存用户信息
    if (info.hasBindRole && !info.hasSelectRegion) {
      // 有缓存用户信息
      dialogHtmlArray.push({
        html: '<div class="region-dialog-wraper_cache-role-list">'
      });

      let listArray = [];
      if (Array.isArray(roleList) && roleList.length > 0) {
        roleList.forEach((role, index) => {
          let dom = {};
          let roleDialogGift = `<div class="role-dialog-gift role-dialog-gift_index${index} ${
            info.currentSelectCacheRoleIndex === index ? 'role-dialog-gift_selected' : ''
          }">
                                                <div class="role-dialog-gift_left">
                                                    <div class="role-dialog-gift_title">${role.character_name ||
                                                      ''}</div>
                                                    <div class="role-dialog-gift_content">${role.partition_name ||
                                                      ''}</div>
                                                </div>
                                                <div class="role-dialog-gift_right">
                                                    <img class="role-dialog-gift_right-selected" src="//mmgame.qpic.cn/image/5bf22e2babff8ebdb7302ecb3e75d7ca00c52192b1853b03569569074ca5e5e7/0" />
                                                </div>
                                            </div>`;
          dom.html = roleDialogGift;
          dom.target = `.role-dialog-gift_index${index}`;
          dom.callback = function() {
            options.savedRoleSelectHandler(index);
          };
          listArray.push(dom);
        });
      }

      dialogHtmlArray = dialogHtmlArray.concat(listArray);

      dialogHtmlArray.push({
        html: '<div class="role-dialog-other">选择其他角色</div>',
        target: '.role-dialog-other',
        callback: options.selectOtherRole
      });

      dialogHtmlArray.push({
        html: '</div>'
      });

      info.currentTargetPageName = 'saved';
    } else {
      info.currentTargetPageName = 'role';
      // 无缓存角色信息
      if (!info.currentRegion) {
        // 当前未选择区服
        let selectRegionHtml = {
          html: `<div class="role-dialog-gift role-dialog-region_select">
                                <div class="role-dialog-gift_left">
                                    <div class="role-dialog-gift_title">选择区服</div>
                                </div>
                                <div class="role-dialog-gift_right">
                                    <img class="role-dialog-gift_right-arrow" src="//res.wx.qq.com/wechatgame/product/cdn/welfare/Arrow_1fb5f9ac.png" />
                                </div>
                            </div>`,
          target: '.role-dialog-region_select',
          callback: options.selectRegion
        };
        dialogHtmlArray.push(selectRegionHtml);
      } else {
        // 已选择区服
        if (roleList.length > 1) {
          // 当前区服多账号
          let regionDom = {};
          let regionDialogGift = `<div class="role-dialog-gift role-dialog-region_select">
                                                <div class="role-dialog-gift_left">
                                                    <div class="region-dialog-gift_content">${info.currentRegion.t}</div>
                                                </div>
                                                <div class="role-dialog-gift_right">
                                                    <img class="role-dialog-gift_right-arrow" src="//res.wx.qq.com/wechatgame/product/cdn/welfare/Arrow_1fb5f9ac.png" />
                                                </div>
                                            </div>`;
          regionDom.html = regionDialogGift;
          regionDom.target = `.role-dialog-region_select`;
          regionDom.callback = options.selectRegion;
          dialogHtmlArray.push(regionDom);
          // 默认选择第一个角色
          let roleDom = {};
          let roleDialogGift = `<div class="role-dialog-gift role-dialog-role_select">
                                                <div class="role-dialog-gift_left">
                                                    <div class="region-dialog-gift_content">${
                                                      roleList[info.currentSelectRegionRoleIndex]
                                                        .character_name
                                                    }</div>
                                                </div>
                                                <div class="role-dialog-gift_right">
                                                    <img class="role-dialog-gift_right-arrow" src="//res.wx.qq.com/wechatgame/product/cdn/welfare/Arrow_1fb5f9ac.png" />
                                                </div>
                                            </div>`;
          roleDom.html = roleDialogGift;
          roleDom.target = `.role-dialog-role_select`;
          roleDom.callback = options.selectRegionRole;
          dialogHtmlArray.push(roleDom);
        } else if (roleList.length === 1) {
          // 当前区服只有一个账号
          let role = roleList[0];
          // 角色自动选定
          info.isCurrentRoleSaved = false;
          info.currentRole = role;

          let dom = {};
          let roleDialogGift = `<div class="role-dialog-gift role-dialog-gift_index0">
                                                <div class="role-dialog-gift_left">
                                                    <div class="role-dialog-gift_title">${role.character_name ||
                                                      ''}</div>
                                                    <div class="role-dialog-gift_content">${info
                                                      .currentRegion.t || ''}</div>
                                                </div>
                                                <div class="role-dialog-gift_right">
                                                    <img class="role-dialog-gift_right-arrow" src="//res.wx.qq.com/wechatgame/product/cdn/welfare/Arrow_1fb5f9ac.png" />                                                    
                                                </div>
                                            </div>`;
          dom.html = roleDialogGift;
          dom.target = `.role-dialog-gift_index0`;
          dom.callback = options.selectRegion;
          dialogHtmlArray.push(dom);
        } else {
          // 当前区服无账号
          let dom = {};
          let roleDialogGift = `<div class="role-dialog-gift role-dialog-region_select">
                                                <div class="role-dialog-gift_left">
                                                    <div class="role-dialog-gift_title">${info.currentRegion.t}</div>
                                                    <div class="role-dialog-gift_content role-dialog-gift_content-norole">该区服未找到角色</div>
                                                </div>
                                                <div class="role-dialog-gift_right">
                                                    <img class="role-dialog-gift_right-arrow" src="//res.wx.qq.com/wechatgame/product/cdn/welfare/Arrow_1fb5f9ac.png" />
                                                </div>
                                            </div>`;
          dom.html = roleDialogGift;
          dom.target = `.role-dialog-region_select`;
          dom.callback = options.selectRegion;
          dialogHtmlArray.push(dom);
        }
      }
    }

    let dialogButtons = options.getRoleListButtons();

    return {
      dialogHtmlArray,
      dialogButtons
    };
  },

  getRoleListButtons: function() {
    let dialogButtons = [
      {
        label: '取消',
        type: 'default',
        callback: function() {
          Report11332.report({
            iSceneId: 34,
            iUIArea: 3414,
            iPositionId: 8,
            iActionId: 2,
            sGameId: info.currentAppId
          });
          info.cancelCallback && info.cancelCallback();
        }
      }
    ];
    let confirmButton = null;

    let roleInfo = {
      parname:
        info.isCurrentRoleSaved && !info.hasSelectRegion
          ? (info.currentRole || {}).partition_name
          : (info.currentRegion || {}).t,
      partition:
        info.isCurrentRoleSaved && !info.hasSelectRegion
          ? (info.currentRole || {}).partition
          : (info.currentRegion || {}).v,
      charac_name: (info.currentRole || {}).character_name,
      charac_no: (info.currentRole || {}).character_no
    };

    if (roleInfo.parname && roleInfo.partition && roleInfo.charac_name && roleInfo.charac_no) {
      confirmButton = {
        label: info.confirmText,
        type: 'primary',
        callback: function() {
          // 当点击确认领取时，手动绑定角色，返回当前绑定的区服及角色信息
          let cgi = '/cgi-bin/gamegiftwap/bindrole';
          let param = {
            appid: info.currentAppId,
            plattype: WXGAME.Env.isiOS ? 0 : 1,
            partition: Number(roleInfo.partition),
            partition_name: roleInfo.parname,
            roleid: roleInfo.charac_no,
            rolename: roleInfo.charac_name
          };
          cgi = options.cgiTool(cgi, param);
          WXGAME.xhrCallCgi(
            cgi,
            {
              method: 'GET'
            },
            function(res) {
              info.receiveCallback(roleInfo);
            },
            function(err) {
              info.failCallback &&
                info.failCallback({
                  type: 'bindrole',
                  error: err
                });
            }
          );
        }
      };
    } else {
      confirmButton = {
        label: info.confirmText,
        type: 'primary-disabled',
        closeDialog: false,
        callback: function() {}
      };
    }
    dialogButtons.push(confirmButton);

    return dialogButtons;
  },

  getPartitionConfig: function() {
    let roleDialogTitle = `<div class="role-dialog-title region-dialog-title">
                                    <div class="region-dialog-title_arrow">
                                        <img class="region-dialog-title_arrow-img" src="//res.wx.qq.com/wechatgame/product/cdn/welfare/back_0990b85b.png" />
                                    </div>
                                    <div class="region-dialog-title_text">选择区服</div>
                                </div>`;
    let dialogHtmlArray = [
      {
        html: roleDialogTitle,
        target: '.region-dialog-title',
        callback: function() {
          if (!info.clickLocked) {
            options.selectRole();
          }
        }
      }
    ];
    let regionList = info.currentRegionList;

    dialogHtmlArray.push({
      html: '<div class="region-dialog-wraper_region-list">'
    });
    // 请求当前游戏区服信息，更新半屏弹窗内容
    let listArray = [];
    if (Array.isArray(regionList) && regionList.length > 0) {
      regionList.forEach((region, index) => {
        let dom = {};
        let roleDialogGift = `<div class="role-dialog-gift role-dialog-gift_index${index} ${
          info.currentSelectRegionIndex === index ? 'role-dialog-gift_selected' : ''
        }">
                                            <div class="role-dialog-gift_left">
                                                <div class="region-dialog-gift_content">${
                                                  region.t
                                                }</div>
                                            </div>
                                            <div class="role-dialog-gift_right">
                                                <img class="role-dialog-gift_right-selected" src="//mmgame.qpic.cn/image/5bf22e2babff8ebdb7302ecb3e75d7ca00c52192b1853b03569569074ca5e5e7/0" />
                                            </div>
                                        </div>`;
        dom.html = roleDialogGift;
        dom.target = `.role-dialog-gift_index${index}`;
        dom.callback = function() {
          options.regionSelectHandler(index);
        };

        listArray.push(dom);
      });
    }

    dialogHtmlArray = dialogHtmlArray.concat(listArray);

    dialogHtmlArray.push({
      html: '</div>'
    });

    info.currentTargetPageName = 'region';

    return {
      dialogHtmlArray
    };
  },

  regionSelectHandler: function(index) {
    info.currentSelectRegionIndex = index;
    // 区服列表选择
    Report11332.report({
      iSceneId: 34,
      iUIArea: 3414,
      iPositionId: 11,
      iActionId: 2,
      sGameId: info.currentAppId
    });

    // 设置选择区服并更新对应UI, 其他的删除selected class，target增加selected class
    let selectItems = document.querySelectorAll('.role-dialog-gift');
    for (let i = 0; i < selectItems.length; i++) {
      selectItems[i].classList.remove('role-dialog-gift_selected');
    }
    selectItems[index] && selectItems[index].classList.add('role-dialog-gift_selected');

    if (index > -1) {
      info.hasSelectRegion = true;
      info.currentRegion = info.currentRegionList[index];
      info.currentRole = {};
    }

    options.getPartitionUserList(info.currentAppId, function() {
      options.selectRole();
    });
  },

  selectOtherRole: function(e) {
    // 选择其他角色
    Report11332.report({
      iSceneId: 34,
      iUIArea: 3414,
      iPositionId: 7,
      iActionId: 2,
      sGameId: info.currentAppId
    });
    info.currentFromPageName = 'saved';
    info.selectOtherRole = true;

    if (Array.isArray(info.currentRegionList) && info.currentRegionList.length > 0) {
      let config = options.getPartitionConfig() || {};
      currentDialog.changeData(
        config.dialogHtmlArray || [],
        config.dialogButtons || [],
        options.getAnimationType()
      );
    } else {
      options.getAppPartitionInfo(info.currentAppId, function() {
        // 显示获取到的区服信息
        let config = options.getPartitionConfig() || {};
        currentDialog.changeData(
          config.dialogHtmlArray || [],
          config.dialogButtons || [],
          options.getAnimationType()
        );
      });
    }
  },

  selectRegion: function(e) {
    // 展开区服选择列表
    Report11332.report({
      iSceneId: 34,
      iUIArea: 3414,
      iPositionId: 10,
      iActionId: 2,
      sGameId: info.currentAppId
    });
    info.currentFromPageName = 'role';

    if (Array.isArray(info.currentRegionList) && info.currentRegionList.length > 0) {
      let config = options.getPartitionConfig() || {};
      currentDialog.changeData(
        config.dialogHtmlArray || [],
        config.dialogButtons || [],
        options.getAnimationType()
      );
    } else {
      options.getAppPartitionInfo(info.currentAppId, function() {
        // 显示获取到的区服信息
        let config = options.getPartitionConfig() || {};
        currentDialog.changeData(
          config.dialogHtmlArray || [],
          config.dialogButtons || [],
          options.getAnimationType()
        );
      });
    }
  },

  savedRoleSelectHandler: function(index) {
    // 选择缓存角色
    info.isCurrentRoleSaved = true;
    options.roleSelectHandler(index, true);
  },

  roleSelectHandler: function(index, isFromSavedList = false) {
    if (isFromSavedList) {
      info.currentSelectCacheRoleIndex = index;
    } else {
      info.currentSelectRegionRoleIndex = index;
    }

    // 角色列表选择
    Report11332.report({
      iSceneId: 34,
      iUIArea: 3414,
      iPositionId: 13,
      iActionId: 2,
      sGameId: info.currentAppId
    });

    // 设置领取角色并更新对应UI, 其他的删除selected class，target增加selected class
    let selectItems = document.querySelectorAll('.role-dialog-gift');
    for (let i = 0; i < selectItems.length; i++) {
      selectItems[i].classList.remove('role-dialog-gift_selected');
    }
    selectItems[index] && selectItems[index].classList.add('role-dialog-gift_selected');

    if (index > -1) {
      info.currentRole = info.currentRoleList[index];
      if (!isFromSavedList) {
        info.isCurrentRoleSaved = false;
      } else {
        // 修改按钮为可选
        currentDialog.changeButton(options.getRoleListButtons());
      }
    }

    if (info.currentRegion) {
      // 当前已绑定区服，则返回角色选择页面
      setTimeout(() => {
        options.selectRole();
      }, 200);
    }
  },

  selectRole: function(e) {
    let className = ((e || {}).target || {}).className;
    // 当点击标题文案时不切换页面
    if (!className || className.indexOf('region-dialog-title_text') === -1) {
      // 展开角色列表
      Report11332.report({
        iSceneId: 34,
        iUIArea: 3414,
        iPositionId: 12,
        iActionId: 2,
        sGameId: info.currentAppId
      });
      info.currentFromPageName = 'region';
      let config = options.getRoleListConfig() || {};
      currentDialog.changeData(
        config.dialogHtmlArray || [],
        config.dialogButtons || [],
        options.getAnimationType()
      );
    }
  },

  selectRegionRole: function() {
    info.currentFromPageName = 'role';
    info.currentTargetPageName = 'regionRole';
    let config = options.getRegionRoleListConfig() || {};
    currentDialog.changeData(
      config.dialogHtmlArray || [],
      config.dialogButtons || [],
      options.getAnimationType()
    );
  },

  getRegionRoleListConfig: function() {
    let roleDialogTitle = `<div class="role-dialog-title region-dialog-title">
                                    <div class="region-dialog-title_arrow">
                                        <img class="region-dialog-title_arrow-img" src="//res.wx.qq.com/wechatgame/product/cdn/welfare/back_0990b85b.png" />
                                    </div>
                                    <div class="region-dialog-title_text">${info.titleText}</div>
                                </div>`;
    let dialogHtmlArray = [
      {
        html: roleDialogTitle,
        target: '.region-dialog-title',
        callback: options.selectRole
      }
    ];
    let roleList = info.currentRoleList;
    // 请求当前游戏区服信息，更新半屏弹窗内容
    dialogHtmlArray.push({
      html: '<div class="region-dialog-wraper_region-list">'
    });
    let listArray = [];
    if (Array.isArray(roleList) && roleList.length > 0) {
      roleList.forEach((role, index) => {
        let dom = {};
        let roleDialogGift = `<div class="role-dialog-gift role-dialog-gift_index${index} ${
          info.currentSelectRegionRoleIndex === index ? 'role-dialog-gift_selected' : ''
        }">
                                            <div class="role-dialog-gift_left">
                                                <div class="region-dialog-gift_content">${
                                                  role.character_name
                                                }</div>
                                            </div>
                                            <div class="role-dialog-gift_right">
                                                <img class="role-dialog-gift_right-selected" src="//mmgame.qpic.cn/image/5bf22e2babff8ebdb7302ecb3e75d7ca00c52192b1853b03569569074ca5e5e7/0" />
                                            </div>
                                        </div>`;
        dom.html = roleDialogGift;
        dom.target = `.role-dialog-gift_index${index}`;
        dom.callback = function() {
          options.roleSelectHandler(index);
        };

        listArray.push(dom);
      });
    }

    dialogHtmlArray = dialogHtmlArray.concat(listArray);

    dialogHtmlArray.push({
      html: '</div>'
    });

    return {
      dialogHtmlArray
    };
  }
};

function HalfScreenRegion(params) {
  this.init(params);
}

HalfScreenRegion.prototype.init = function(params) {
  options.insertStyle();

  info.clickLocked = false;
  params.confirmText && (info.confirmText = params.confirmText);
  params.cancelText && (info.cancelText = params.cancelText);
  params.titleText && (info.titleText = params.titleText);
  params.regionList && (info.currentRegionList = params.regionList);

  if (info.currentAppId) {
    // 相同游戏，不需再次请求区服信息
    if (info.currentAppId === params.appid) {
      info.isSameGame = true;
    } else {
      info.isSameGame = false;
    }
  }

  info.ssid = params.ssid || 0;
  // 曝光上报
  Report11332.report({
    iSceneId: 34,
    iUIArea: 3414,
    iActionId: 1,
    iPositionId: 0,
    iOpType: 1,
    sGameId: info.currentAppId
  });

  options.resetInfo();

  let appid = params.appid;
  info.currentAppId = appid;
  params.receiveCallback && (info.receiveCallback = params.receiveCallback);
  params.cancelCallback && (info.cancelCallback = params.cancelCallback);
  params.failCallback && (info.failCallback = params.failCallback);

  options.getUserAppRoleList(function() {
    // 根据当前领取的appid，判断appRoleListMap对应rolelist是否为空，若为空，则无角色缓存，显示无缓存交互；否则，显示缓存交互
    let roleList = ((info.appRoleListMap || {})[appid] || {}).role_list || [];
    info.currentRoleList = roleList;

    if (Array.isArray(roleList) && roleList.length > 0) {
      info.hasBindRole = true;
      info.currentSelectCacheRoleIndex = 0;
      info.currentRole = roleList[info.currentSelectCacheRoleIndex];
      info.isCurrentRoleSaved = true;
    }

    let config = options.getRoleListConfig() || {};

    currentDialog = params.dialog;
    currentDialog.changeData(config.dialogHtmlArray || [], config.dialogButtons || []);
  });
};

//module.exports = HalfScreenRegion;
export default HalfScreenRegion;
